export * from './lib/state/allegati.query';
export * from './lib/state/allegati.service';
export * from './lib/state/allegati.store';
